/**
 * Parses string values, attempting JSON parse first, fallback to string
 */
const parseValue = (value: string): unknown => {
  if (!value || typeof value !== 'string') return value;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

/**
 * Filters out empty key-value pairs and parses values in JSON format.
 */
export const getValidKeyValuePairs = (
  data: Record<string, string>
): Record<string, unknown> => {
  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      const trimmedKey = key.trim();
      const trimmedValue = value.trim();
      if (trimmedKey && trimmedValue) {
        acc[trimmedKey] = parseValue(trimmedValue);
      }
      return acc;
    },
    {} as Record<string, unknown>
  );
};
